import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import ForwarderHeaderInvoiceBalanceContainer from '../../../forwarderHeaderInvoiceBalance/ForwarderHeaderInvoiceBalanceContainer';

import Cart from '../../../../models/Cart';
import { UserRoleType } from '../../../../models/User';

import styles from './paymentHeaderStyles.module.css';

import { formatCurrency } from '../../../../utils/currencyFormatter';

interface PaymentHeaderProps {
  cart?: Cart;
  userRole: UserRoleType;
};

class PaymentHeaderContainer extends Component<PaymentHeaderProps>  {

  render() {
    const headerContainerStyle: string = this.props.userRole === UserRoleType.GHA ? [styles.headerContainer, styles.headerContainerGha].join(' ') : styles.headerContainer;
    return (
      <Fragment>
        <div className={ styles.pHeaderContainer }>
          { this.props.cart && this.props.cart.items.length > 0 && 
            <span className={ headerContainerStyle }>
              <span className={ styles.greyText }> Total Amount Due: </span>
              <span className={ styles.blueText }> {formatCurrency(this.props.cart.remainDue, 2, '$')} </span>
            </span>
          }
          { this.props.userRole === UserRoleType.FORWARDER &&
            <ForwarderHeaderInvoiceBalanceContainer cssClassName={ styles.invoiceBallancePayment } />
          }
        </div>  
      </Fragment>
    )
  };
};

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart
  };
};

export default connect(mapStateToProps, null)(PaymentHeaderContainer);
